import React from 'react';
import { connect } from 'react-redux';
import { actions } from './actions';
import { Label, Checkbox } from "./../checkbox/CheckBox";
import withLocalized from '../../../localization/withLocalized';
import { ENGLAND, FINLAND, IRELAND, NORTHERN_IRELAND, SCOTLAND, WALES, USA, ESTONIA } from './constants'
import Notification from './../modal/Notification';
import { ThemeProvider } from 'styled-components';
import themes from './../ui/themes';

import './AreaSelect.css'

import fi from './flags/flag_finland.png';
import ie from './flags/flag_ireland.png';
import gb from './flags/flag_england.png';
import scotland from './flags/flag_scotland.png';
import n_ireland from './flags/flag_northern_ireland.png';
import wales from './flags/flag_wales.png';
import usa from './flags/flag_usa.png';
import estonia from './flags/flag_estonia.png';

import { APP_THEME } from 'config'

const areaClick = (event, handler, payload, market) =>{
    const isGlobal = (process.env.REACT_APP_NODE_ENV === 'ie' || process.env.REACT_APP_NODE_ENV === 'test');
    if ((isGlobal && market === 'com') || (!isGlobal && market === 'fi')){
        event.preventDefault();
        handler(payload, false);
    }
}


let AreaSelect = ({ onClose, setArea, hideArea, localized, showAreaSelect }) => {
    return(
        <Notification
            isOpen={showAreaSelect}
            onClose={hideArea}
            title={localized('areaselect.notification_title')}
            notificationLayout
        >
            <ThemeProvider theme={themes[APP_THEME]}>
                <div className="select-countries">
                    <p className="select-countries--content">
                        {localized('areaselect.content')}
                    </p>
                    <ul className="select-countries--list">
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${ENGLAND}`} className="select-countries--link" onClick={event => areaClick(event, setArea, ENGLAND, 'com')}>
                                <img className="select-countries--icon" src={gb} alt={ENGLAND} /> {localized(`areaselect.areas.${ENGLAND}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${IRELAND}`} className="select-countries--link" onClick={event => areaClick(event, setArea, IRELAND, 'com')}>
                                <img className="select-countries--icon" src={ie} alt={IRELAND} /> {localized(`areaselect.areas.${IRELAND}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${NORTHERN_IRELAND}`} className="select-countries--link" onClick={event => areaClick(event, setArea, NORTHERN_IRELAND, 'com')}>
                                <img className="select-countries--icon" src={n_ireland} alt={NORTHERN_IRELAND} /> {localized(`areaselect.areas.${NORTHERN_IRELAND}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${SCOTLAND}`} className="select-countries--link" onClick={event => areaClick(event, setArea, SCOTLAND, 'com')}>
                                <img className="select-countries--icon" src={scotland} alt={SCOTLAND} /> {localized(`areaselect.areas.${SCOTLAND}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${USA}`} className="select-countries--link" onClick={event => areaClick(event, setArea, USA, 'com')}>
                                <img className="select-countries--icon" src={usa} alt={USA} /> {localized(`areaselect.areas.${USA}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${WALES}`} className="select-countries--link" onClick={event => areaClick(event, setArea, WALES, 'com')}>
                                <img className="select-countries--icon" src={wales} alt={WALES} /> {localized(`areaselect.areas.${WALES}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://birdietime.com${document.location.pathname}?setarea=${ESTONIA}`} className="select-countries--link" onClick={event => areaClick(event, setArea, ESTONIA, 'com')}>
                                <img className="select-countries--icon" src={estonia} alt={ESTONIA} /> {localized(`areaselect.areas.${ESTONIA}`)}
                            </a>
                        </li>
                        <li className="select-countries--item">
                            <a href={`https://fi.birdietime.com${document.location.pathname}?setarea=${FINLAND}`} className="select-countries--link" onClick={event => areaClick(event, setArea, FINLAND, 'fi')}>
                                <img className="select-countries--icon" src={fi} alt={FINLAND} /> {localized(`areaselect.areas.${FINLAND}`)}
                            </a>
                        </li>
                    </ul>
                    <p>
                        <Label style={{ color: '#6F6F6F', fontSize: '1.0625rem', fontFamily: 'Helvetica' }}>
                            <Checkbox type="checkbox" onChange={({ target: { checked } }) => { try { localStorage.setItem('dismiss-area-select', checked) } catch (e) { } }} /> {localized('areaselect.dismiss')}
                        </Label>
                    </p>
                </div>
            </ThemeProvider>
        </Notification>
    )
}



const mapStateToProps = (state) => {
    return {
        ...state.area
    }
};

AreaSelect = connect(
    mapStateToProps,
    Object.assign({}, actions),
)(AreaSelect);

export default withLocalized(AreaSelect);



// WEBPACK FOOTER //
// ./src/modules/common/components/areaselect/AreaSelect.js